export const ctaBox = {
  float: ['left', 'right'],
  marginRight: [0, 12],
  paddingBottom: ['sm', 48]
}

export const ctaHelpText = {
  marginRight: [0, 32],
  marginBottom: [24, 0],
  display: ['block', 'inline']
}

export const cta = {
  display: 'inline-flex'
}

export const count = {
  marginTop: 30,
  marginBottom: 30
}
